/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessTypeStat
 */
export interface BusinessTypeStat {
    /**
     * 业务类型名称
     * @type {string}
     * @memberof BusinessTypeStat
     */
    typeName?: string;
    /**
     * 订单数量
     * @type {number}
     * @memberof BusinessTypeStat
     */
    count?: number;
    /**
     * 占比(%)
     * @type {number}
     * @memberof BusinessTypeStat
     */
    percentage?: number;
}

/**
 * Check if a given object implements the BusinessTypeStat interface.
 */
export function instanceOfBusinessTypeStat(value: object): value is BusinessTypeStat {
    return true;
}

export function BusinessTypeStatFromJSON(json: any): BusinessTypeStat {
    return BusinessTypeStatFromJSONTyped(json, false);
}

export function BusinessTypeStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessTypeStat {
    if (json == null) {
        return json;
    }
    return {
        
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'count': json['count'] == null ? undefined : json['count'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
    };
}

export function BusinessTypeStatToJSON(json: any): BusinessTypeStat {
    return BusinessTypeStatToJSONTyped(json, false);
}

export function BusinessTypeStatToJSONTyped(value?: BusinessTypeStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'typeName': value['typeName'],
        'count': value['count'],
        'percentage': value['percentage'],
    };
}

